import { render, staticRenderFns } from "./AvenantModal.vue?vue&type=template&id=8b3c95e6"
import script from "./AvenantModal.vue?vue&type=script&lang=ts"
export * from "./AvenantModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports